module.exports = __webpack_public_path__ + "static/media/burrito_01_thumb.3d7e4429.png";